import React, { useEffect, useState,useContext } from 'react'
import { collection, query, orderBy, onSnapshot } from "firebase/firestore"
import { app, database, storage } from '../../../firebaseConfig'
import { DataGrid, frFR, GridToolbar } from '@mui/x-data-grid'
import dateFormat, { masks } from "dateformat";
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';
function Doleance() {
    const { user } = useContext(AuthContext);
    const [loadingData, setLoadingData] = useState(false)
    const [doleances, setDoleances] = useState([])
    const columns = [
        {
            field: 'date',
            headerName: 'DATE',
            minWidth: 200,
            valueGetter: (value) => {
                return `${dateFormat(new Date(value.row.date),"dd/mm/yyyy")}`;
            },
        },
        {
            field: 'sentiment',
            headerName: 'REACTION',
            minWidth: 200
        },
        {
            field: 'remarque',
            headerName: 'REMARQUE',
            minWidth: 400
        },
    ]
    useEffect(() => {
        setLoadingData(true)
        const q = query(collection(database, 'doleance'))
        onSnapshot(q, (querySnapshot) => {
            setDoleances(querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })))

        })
        setLoadingData(false)
    }, [])
    if(user.type !='Responsable Centrale'){
        return <AccessDinied />
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <div style={{ width: '100%', height: 450 }}>
                <DataGrid rowSelection={false}
                    columns={columns}
                    rows={doleances}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10, 25, 100]}
                    sx={{ marginTop: 2 }}
                    loading={loadingData}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            printOptions: { disableToolbarButton: true },
                            csvOptions: {
                                fileName: 'doleance_csv_' + dateFormat(new Date(), 'yyyymmddHHMMss'),
                                delimiter: ',',
                                utf8WithBom: true,
                            }
                        }
                    }}
                    localeText={frFR.components.MuiDataGrid.defaultProps.localeText} />
            </div>
        </div>
    )
}

export default Doleance